import { Banner, PublicDomainConfigData } from "@convin/type/Domain";

class PublicDomainInstance {
    #domainConfig: PublicDomainConfigData;
    readonly logo: string | null;
    readonly brand: string | null;
    readonly version: number;
    readonly tenant_name: string;
    readonly ai_agent_host: string | null;

    constructor(domainConfig: PublicDomainConfigData) {
        this.#domainConfig = domainConfig;
        this.logo = domainConfig.logo;
        this.brand = domainConfig.brand;
        this.version = domainConfig.version;
        this.tenant_name = domainConfig.tenant_name;
        this.ai_agent_host = domainConfig.ai_agent_host;
    }

    getBanners(): Banner[] | undefined {
        return this.#domainConfig.domain_banners;
    }

    getSsoProviders(): string[] {
        return (
            this.#domainConfig.sso_providers?.map((provider) =>
                provider.toLowerCase()
            ) ?? []
        );
    }
}

export default PublicDomainInstance;
